export default __webpack_public_path__ + "static/media/singleProduct.26889ebe.svg";